<template>
	<div class="default-input" :class="{'default-input--error' : errors.length, 'default-input--bg' : inputGray }">
		<label class="default-input__label" v-if="label" :for="id">{{ label }}</label>
		<div class="default-input__wrapper">
			<div class="default-input__input">
				<textarea ref="inputTextarea"  v-model="value" :placeholder="placeholder" :id="id" :disabled="disabled" :readonly="readonly"></textarea>
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li>{{ errors[0].$message }}</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "InputTextarea",
	props: {
		modelValue: {
			type: String,
			default: ''
		},
		id: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	}
}
</script>

